import React from "react";
import { Box, Card, Typography } from "@mui/material";
import { useScreenSize } from "globals/hooks";
import { Request } from "types";
import TermsSignButton from "../TermsSignButton";

type TermsAndConditionsCardProps = {
  request: Request;
  refetchRequest?: () => void;
};

function TermsAndConditionsCard({ request, refetchRequest }: TermsAndConditionsCardProps) {
  const { isMobileView } = useScreenSize();

  return (
    <Card variant="outlined" sx={{ mb: isMobileView ? 2 : 3 }}>
      <Box
        display="flex"
        flexDirection="column"
        m={3}
      >
        <Typography variant="h3" mb={2}>
          Terms and Conditions
        </Typography>
        <Box>
          <TermsSignButton request={request} refetchRequest={refetchRequest} />
        </Box>
      </Box>
    </Card>
  );
}

export default TermsAndConditionsCard;